import { css, StyleSheet } from 'aphrodite';
import React, { useState } from 'react';
import Image from 'react-bootstrap/Image';
import { Link, Element} from 'react-scroll'

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import title from './assets/images/highlight.jpg';
import titleMobile from './assets/images/highlight-mobile.jpg';
import logoDark from './assets/images/logo-dark.svg';
import logo from './assets/images/logo.svg';

import Menu from './Menu';
import About from './About';
import MapComponent from './Map';
import Certificates from './Certificates';
import Footer from './Footer';

function App() {
  const translateKeyframes = {
    '0%': {
      transform: 'translateX(100%)',
    },

    '100%': {
      transform: 'translateX(0)',
    },
  };

  const opacityKeyframes = {
    'from': {
      opacity: 0,
    },

    'to': {
      opacity: 1,
    }
  };
  const styles = StyleSheet.create({
    app: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0.5em',
      margin: 0,
      backgroundColor: '#fff',
      width: '100%',
      height: '80px',
    },
    logo: {
      padding: '16px',
      width: 'auto',
      height: '100%',
      cursor: 'pointer',
    },
    title: {
      width: '100%',
      backgroundImage: `url(${title})`,
      backgroundColor: 'grey', /* Used if the image is unavailable */
      minHeight: '500px', /* You must set a specified height */
      height: '70vh',
      backgroundPosition: 'center', /* Center the image */
      backgroundRepeat: 'no-repeat', /* Do not repeat the image */
      backgroundSize: 'cover', /* Resize the background image to cover the entire container */
      '@media (max-width: 600px)': {
        backgroundImage: `url(${titleMobile})`,
      }
    },
    overlay: {
      position: 'relative',
      backgroundColor: 'rgba(0,0,0,0.5)',
      width: '100%',
      height: '100%',
      color: 'white',
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      ':hover': {
        //backgroundColor: 'rgba(0,0,0,0)',
      },
    },
    zippyHeader: {
      textTransform: "uppercase",
      position: "realtive",
      animationName: [opacityKeyframes],
      animationDuration: '3s',
      animationIterationCount: 'one',
      fontSize: 60,
      textAlign: 'justify',
      '@media (max-width: 600px)': {
        textAlign: 'center',
      }
    },
    ul: {
      listStyleType: 'none',
      margin: 0,
      padding: 0,
      cursor: 'pointer',
      display: "block",
      '@media (max-width: 600px)': {
        display: 'none',
      }
    },
    ulVertical: {
      listStyleType: 'none',
      margin: 0,
      padding: 0,
      marginTop: "5em",
      cursor: 'pointer',
      display: "flex",
      flexDirection: "column"
    },
    li: {
      float: 'left',
      color: '#1e2a45',
      fontWeight: 'bold',
      fontSize: 16,
      padding: '16px',
      ':hover': {
        color: '#E7421C',
      },
    },
    menu: {
      position: 'absolute',
      top: 0,
      right: 0,
      backgroundColor: "rgba(255,255,255,0.98)",
      color: 'rgba(30, 42, 69, 1)',
      width: '80%',
      height: '100%',
      zIndex: 100,
      animationName: [translateKeyframes, opacityKeyframes],
      animationDuration: '1s',
      animationIterationCount: 'one',
      overflow: 'hidden',
    }
  });

  const [isShown, setIsShown] = useState(false);
  const [menu, setMenu] = useState(false);


  return (
    <div className={css(styles.app)}>

      <header className={css(styles.header)}>
        <div className={css(styles.logo)}
          onMouseEnter={() => setIsShown(true)}
          onMouseLeave={() => setIsShown(false)}
        >
          <Image src={isShown ? logo : logoDark} alt="Logo" width="auto" height="100%" />
        </div>
        <div style={{ display: "flex" }}>
          <ul className={css(styles.ul)}>
            <li className={css(styles.li)}>
              <Link activeClass="active" to="about" spy={true} smooth={true} duration={500}>O společnosti</Link>
            </li>
            <li className={css(styles.li)}>
              <Link activeClass="active" to="maps" spy={true} smooth={true} duration={500}>Reference</Link>
            </li>
            <li className={css(styles.li)}>
              <Link activeClass="active" to="contact" spy={true} smooth={true} duration={500}>Kontakty</Link>
            </li>
          </ul>
          <Menu setMenu={setMenu} menu={menu}></Menu>
        </div>
      </header>
      <div className={css(styles.menu)} style={{display: menu?"block":"none"}}>
        <ul className={css(styles.ulVertical)}>
          <li className={css(styles.li)}>
              <Link activeClass="active" to="about" spy={true} smooth={true} duration={500}
              onClick={()=> {
                setMenu(false);
                document.body.style.overflow = 'unset'
                }
              }
              >O společnosti</Link>
            </li>
            <li className={css(styles.li)}>
              <Link activeClass="active" to="maps" spy={true} smooth={true} duration={500}
              onClick={()=> {
                setMenu(false);
                document.body.style.overflow = 'unset'
                }
              }>Reference</Link>
            </li>
            <li className={css(styles.li)}>
              <Link activeClass="active" to="contact" spy={true} smooth={true} duration={500}
              onClick={()=> {
                setMenu(false);
                document.body.style.overflow = 'unset'
                }
              }>Kontakty</Link>
            </li>
        </ul>
      </div>
      <div className={css(styles.title)}>
        <div className={css(styles.overlay)}>
          <h1 className={css(styles.zippyHeader)}>Stavíme s rozumem</h1>
        </div>
      </div>
      <Element name="about" id="about" style={{width: "100%"}}>
        <About></About>
      </Element>
      <Element name="maps" id="maps" style={{width: "100%"}}>
        <MapComponent></MapComponent>
      </Element>
      <Element name="cert" id="cert" style={{width: "100%"}}>
        <Certificates></Certificates>
      </Element>
      <Element name="contact" id="contact" style={{width: "100%"}}>
        <Footer></Footer>
      </Element>
    </div>
  );
}

export default App;
